// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__v1Mdc","BreadTop":"BurgerIngredient__BreadTop__30I6U","Seeds1":"BurgerIngredient__Seeds1__2VmWM","Seeds2":"BurgerIngredient__Seeds2__25rjQ","Meat":"BurgerIngredient__Meat__2HYmd","Cheese":"BurgerIngredient__Cheese__3OU0y","Salad":"BurgerIngredient__Salad__PBCV5","Bacon":"BurgerIngredient__Bacon__3Zxv6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredient.css
// module id = 107
// module chunks = 3